<template>
  <ViewWrapper class="summary" footer-orientation="vertical">
    <div class="summary__inner">
      <h2>{{ $t('view.summary.headline') }}</h2>
      <p>{{ $t('view.summary.copy') }}</p>

      <ButtonPill class="summary__pdf" :to="{ name: 'aboutOcean' }">
        {{ $t('view.summary.projects.climate21') }}
      </ButtonPill>
      <ButtonPill class="summary__pdf" :to="{ name: 'about' }">
        {{ $t('view.summary.projects.makeAShift') }}
      </ButtonPill>

      <ButtonPill
        class="summary__pdf"
        :href="'https://www.sap.com/Oxford-Economics-Purpose-Think-Piece'"
        target="_blank"
        :download="isIOS ? undefined : ''"
        >SAP and Purpose</ButtonPill
      >
    </div>

    <template name="footer">
      <div class="summary__footer_buttons">
        <ButtonBubble
          class="summary__button"
          :to="{ name: 'home' }"
          icon="repeat"
          :label="$t('game.playAgain')"
        />
        <Share #default="{ togglePopup }">
          <ButtonBubble
            class="summary__button"
            icon="share"
            :label="$t('feature.share.share')"
            @click="togglePopup"
          />
        </Share>
      </div>
    </template>
  </ViewWrapper>
</template>

<script>
import { playSound } from '../services/sound';

import ButtonPill from '../components/ButtonPill';
import ButtonBubble from '../components/ButtonBubble';
import Share from '../components/Share';
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'Summary',

  components: {
    ButtonPill,
    ButtonBubble,
    Share,
    ViewWrapper,
  },

  mounted() {
    playSound('fxA', 'headline');
  },
};
</script>

<style lang="scss" scoped>
$padding: 100px;

.summary {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-black);

  h2 {
    @include font-headline;
    text-align: center;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }
  p {
    text-align: center;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.summary__inner {
  margin-bottom: 20%;
}

.summary__pdf {
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}

.summary__footer_buttons {
  position: absolute;
  bottom: calc(40px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 60px;
}
</style>
